import { ActionReducer } from '@ngrx/store';
import { clearAllState } from '../actions/app.actions';

// Keys preserved when clearAllState is dispatched:
//   router — must not be reset so the current URL is not lost during logout/account-switch.
//   app    — holds user-independent settings (theme, browserName, externalUrls) that are
//            expensive or unpleasant to re-fetch on every login; these do not carry patient data.
// All other feature slices (user, appointment, messages, patient-lab-results, etc.) are reset
// to their initialState so no patient data persists across account switches.
const PRESERVED_KEYS = ['router', 'app'] as const;

export function clearStateMetaReducer<T>(reducer: ActionReducer<T>): ActionReducer<T> {
  return (state, action) => {
    if (action.type === clearAllState.type) {
      const source = state as unknown as Record<string, unknown> | undefined;
      const preservedState = (PRESERVED_KEYS as readonly string[]).reduce(
        (acc, key) => {
          acc[key] = source?.[key];
          return acc;
        },
        {} as Record<string, unknown>
      );
      return reducer(preservedState as unknown as T, action);
    }
    return reducer(state, action);
  };
}
